<template>
    <div style="margin: 10px">
        <v-form>
            <v-card>
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px"
                            >{{ $t(formName) }}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                        @click="onCancel"
                        icon
                        style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12 sm12 md6>
                            <div style="padding: 20px 10px">
                                <p class="font-weight-bold">
                                    Số biên bản:
                                    {{ this.acceptanceReport.reportNumber }}
                                </p>
                                <div class="font-weight-bold">
                                    Số đề nghị:
                                    {{ this.acceptanceReport.requestOrderNumber }}
                                </div>
                            </div>
                        </v-flex>
                        <v-flex xs12 sm12 md6>
                            <div style="padding: 20px 10px">
                                <p class="font-weight-bold">
                                    Người tạo biên bản:
                                    {{ this.acceptanceReport.userCreateName }}
                                </p>
                            </div>
                        </v-flex>
                        <v-flex xs12 sm12 md6>
                            <div style="padding: 0px 10px; margin-bottom: 20px;">
                                <v-textarea
                                    v-if="showUpdate"
                                    outlined
                                    label="Nội dung"
                                    rows="2"
                                    v-model="acceptanceReport.content"
                                />
                                <template v-else>
                                    <p  class="font-weight-bold"> Nội dung:</p>
                                    <span>{{ acceptanceReport.content }}</span>
                                </template>
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex>
                            <table class="lstTable">
                                <tr>
                                    <th width="7%">Tên dịch vụ</th>
                                    <th width="10%">Nội dung dịch vụ</th>
                                    <th width="5%">Đơn vị</th>
                                    <th width="7%">Kích thước</th>
                                    <th width="10%">Số lượng đề xuất</th>
                                    <th width="10%">Số lượng nghiệm thu</th>
                                    <th>Ngày nghiệm thu</th>
                                    <th width="10%">Nhà cung cấp</th>
                                    <th>Ghi chú</th>
                                    <th width="10%" v-if="showColKst">KST đánh giá</th>
                                    <th width="10%" v-if="showColBgd">BGĐ đánh giá</th>
                                </tr>
                                <template v-for="(item, index) in lstMaterial">
                                    <tr v-if="item.row === 0" :key="index">
                                        <td style="font-weight: bold">{{item.typeName}}</td>
                                        <td colspan="7">Không có dịch vụ</td>
                                    </tr>
                                    <tr v-else :key="index">
                                        <td :rowspan="item.row" v-if="item.row != undefined && parseInt(item.row) > 0" style="font-weight: bold">{{item.typeName}}</td>
                                        <td>{{ item.materialName }}</td>
                                        <td style="text-align: center">{{ item.unit }}</td>
                                        <td style="text-align: center">{{ item.pack }}</td>
                                        <td style="text-align: center">{{ item.buyNumberPropose | currency }}</td>
                                        <td style="text-align: center">
                                            {{ item.quantity | currency }}
                                            <!-- <c-input-number
                                                v-if="showUpdate"
                                                min="0"
                                                v-model="lstMaterial[index].quantity"
                                                @keydown="keyProcess"
                                                :id="'input_' + index"
                                                :data-index="index"
                                                style="text-align: center"
                                            />
                                            <template v-else>
                                                {{ item.quantity | currency }}
                                            </template> -->
                                        </td>
                                        <td style="text-align: center">
                                            <i-datepicker
                                                v-if="showUpdate"
                                                v-model="lstMaterial[index].acceptDate"
                                                :minDate="minDate()"
                                            />
                                            <template v-else>
                                                {{ dateFormat(item.acceptDate) }}
                                            </template>
                                        </td>
                                        <td>
                                            <v-autocomplete
                                                v-if="showUpdate"
                                                :items="lstSupplier"
                                                label="Nhà cung cấp"
                                                v-model="lstMaterial[index].supplyId"
                                                item-value="partnerId"
                                                item-text="partnerName"
                                                clearable
                                            />
                                            <template v-else v-for="(supplier, i) in lstSupplier">
                                                <span v-if="supplier.partnerId == item.supplyId" :key="i">
                                                    {{ supplier.partnerName }}
                                                </span>
                                            </template>
                                        </td>
                                        <td style="text-align: center">
                                            <v-textarea
                                                v-if="showUpdate"
                                                rows="2"
                                                v-model="lstMaterial[index].pur_note"
                                            />
                                            <template v-else>
                                                {{ item.pur_note != undefined ? item.pur_note : '' }}
                                            </template>
                                        </td>
                                        <td v-if="showColKst">
                                            <v-textarea
                                                v-if="isEditEngineerNote"
                                                rows="2"
                                                v-model="lstMaterial[index].engineer_note"
                                            />
                                            <span v-else>{{ lstMaterial[index].engineer_note }}</span>
                                        </td>
                                        <td v-if="showColBgd">
                                            <v-textarea
                                                v-if="isEditDirectorNote"
                                                rows="2"
                                                v-model="lstMaterial[index].director_note"
                                            />
                                            <span v-else>{{ lstMaterial[index].director_note }}</span>
                                        </td>
                                    </tr>
                                </template>
                            </table>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs12 sm12 md6>
                            <div v-if="showColKst" style="padding: 20px 10px">
                                <v-textarea
                                    v-if="showConfirm || showUpdateKst"
                                    outlined
                                    label="Kỹ sư trưởng đánh giá chất lượng"
                                    rows="2"
                                    v-model="acceptanceReport.evalutionEngineer"
                                />
                                <div v-else>
                                    <p class="font-weight-bold">Kỹ sư trưởng đánh giá chất lượng</p>
                                    {{ acceptanceReport.evalutionEngineer }}
                                </div>
                            </div>
                            <div v-if="showColBgd" style="padding: 0px 10px">
                                <v-textarea
                                    v-if="acceptanceReport.status == 2"
                                    outlined
                                    label="Ban giám đốc đánh giá chất lượng"
                                    rows="2"
                                    v-model="acceptanceReport.evalutionDirector"
                                />
                                <div v-else>
                                    <p class="font-weight-bold">Ban giám đốc đánh giá chất lượng</p>
                                    {{ acceptanceReport.evalutionDirector }}
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn v-if="showConfirm" color="success" @click="onConfirm" :disabled="loading">
                        {{ $t("lang.common.confirm") }}
                    </v-btn>
                    <v-btn v-if="showApprove" color="success" @click="onApprove" :disabled="loading">
                        {{ $t("lang.common.approve") }}
                    </v-btn>
                    <v-btn v-if="showReject" color="warning" @click="onReject" :disabled="loading">
                        {{ $t("lang.common.notApprove") }}
                    </v-btn>   
                    <v-btn v-if="showReCreate" color="primary" @click="onReCreate" :disabled="loading">
                        {{ $t("Tạo BBNT mới") }}
                    </v-btn> 
                    <v-btn v-if="showUpdate || showUpdateKst" color="primary" @click="onUpdate" :disabled="loading">
                        {{ $t("lang.common.update") }}
                    </v-btn>
                    <v-btn v-if="showDelete" color="error" @click="onDelete" :disabled="loading">
                        {{ $t("lang.common.delete") }}
                    </v-btn>
                    <v-btn color="grey" @click="onCancel" :disabled="loading">
                        {{ $t("lang.common.back") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>

        <v-dialog
            v-model="confirmDialog"
            persistent
            max-width="290"
        >
            <v-card>
                <v-card-title class="text-h3">
                Bạn có muốn xác nhận phiếu nhập kho này ?
                </v-card-title>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" text  @click="confirmDialog = false">
                    Hủy bỏ
                </v-btn>
                <v-btn color="success" text @click="agreeConfirm">
                    Đồng ý
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="approveDialog"
            persistent
            max-width="290"
        >
            <v-card>
                <v-card-title class="text-h3">
                Bạn có muốn duyệt phiếu nhập kho này ?
                </v-card-title>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" text  @click="approveDialog = false">
                    Hủy bỏ
                </v-btn>
                <v-btn color="success" text @click="agreeApprove">
                    Đồng ý
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="rejectDialog"
            persistent
            max-width="290"
        >
            <v-card>
                <v-card-title class="text-h3">
                Không phê duyệt phiếu nhập kho này ?
                </v-card-title>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" text  @click="rejectDialog = false">
                    Hủy bỏ
                </v-btn>
                <v-btn color="success" text @click="agreeReject">
                    Đồng ý
                </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import IDatepicker from "../../../components/form/DatePicker";
import { message } from "../../../shared/message";
import CTextboxFloat from "@/components/form/TextboxFloat";
import { requestConstants, roleConstants } from "@/constants";

export default {
    name: "AcceptanceReportView",
    components: {CTextboxFloat, IDatepicker },
    data: () => {
        return {
            formName: "Biên bản nghiệm thu",
            loading: false,
            warehouseCode: "",
            roleGroup: 0,
            isEdit: false,
            deleteDialog: false,
            materials: [],
            lstSupplier: [],
            lstWarehouse: [],
            lstMaterialType: [],
            lstMaterial: [],
            requestOrder: null,
            acceptanceReport: {
                areaId: '',
                content: '',
                evalutionDirector: '',
                evalutionEngineer: '',
                reportId: '',
                reportNumber: '',
                reqOrdId: '',
                requestData: '',
                requestOrderNumber: '',
                status: 1,
                userCreateId: '',
                userCreateName: '',
                warehouseId: 0,
            },
            historyDlg: false,
            lstHistory: [],
            confirmDialog: false,
            approveDialog: false,
            rejectDialog: false,
        };
    },

    created() {
        // 2: thủ kho;  26: mua hàng
        const role = parseInt(this.$store.state.auth.user.role);
        if (role == 26 || role == 3) {
            this.roleGroup = 1;
        } else if (role == 4) {
            this.roleGroup = 2;
        } else if (role == 1) {
            this.roleGroup = 3;
        } else {
            this.$router.push({ path: '/acceptanceReport', query: this.$route.query });
        }

        this.getAcceptanceReport();
        this.getSuppliers();
    },

    computed: {
        showColBgd() {
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
                || this.acceptanceReport.status == requestConstants.acceptanceReportStatusCons.approved
                || this.acceptanceReport.status == requestConstants.acceptanceReportStatusCons.rejected) {
                return true;
            } else {
                return false;
            }
        },
        showColKst() {
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE
                && this.acceptanceReport.status == requestConstants.acceptanceReportStatusCons.waitConfirm) {
                return false;
            } else {
                return true;
            }
        },
        isEditEngineerNote() {
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER && this.acceptanceReport.status == requestConstants.acceptanceReportStatusCons.waitConfirm
                || this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER && this.acceptanceReport.status == requestConstants.acceptanceReportStatusCons.waitApprove
                ) {
                return true;
            } else {
                return false;
            }
        },
        isEditDirectorNote() {
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR && this.acceptanceReport.status == requestConstants.acceptanceReportStatusCons.waitApprove) {
                return true;
            } else {
                return false;
            }
        },
        showConfirm() {
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
                && this.acceptanceReport.status == requestConstants.acceptanceReportStatusCons.waitConfirm) {
                return true;
            } else {
                return false;
            }
        },
        showApprove() {
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
                && this.acceptanceReport.status == requestConstants.acceptanceReportStatusCons.waitApprove) {
                return true;
            } else {
                return false;
            }
        },
        showReject() {
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.DIRECTOR
                && this.acceptanceReport.status == requestConstants.acceptanceReportStatusCons.waitApprove) {
                return true;
            } else {
                return false;
            }
        },
        showUpdate() {
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE
                && this.acceptanceReport.status == requestConstants.acceptanceReportStatusCons.waitConfirm) {
                return true;
            } else {
                return false;
            }
        },
        showUpdateKst() {
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.CHIEF_ENGINEER
                && this.acceptanceReport.status == requestConstants.acceptanceReportStatusCons.waitApprove) {
                return true;
            } else {
                return false;
            }
        },
        showDelete() {
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE
                && this.acceptanceReport.status == requestConstants.acceptanceReportStatusCons.waitConfirm) {
                return true;
            } else {
                return false;
            }
        },
        showReCreate() {
            if (this.$store.state.auth.user.role == roleConstants.ROLE_CONSTANTS.PURCHASE
                && this.acceptanceReport.status == requestConstants.acceptanceReportStatusCons.rejected) {
                return true;
            } else {
                return false;
            }
        },
        showEvalutionDirector() {
            return true;
        },
    },

    methods: {
        onCancel() {
            this.$router.push({ path: '/acceptanceReport', query: this.$route.query });
        },
        onSave() {
            const createItem = this.acceptanceReport;
            createItem.requestData = JSON.stringify(this.lstMaterial);
            // return;
            this.loading = true;
            axios
                .post(process.env.VUE_APP_API_URL + "/acceptanceReport/save", createItem)
                .then(
                    (data) => {
                        if (data.success) {
                            message.success( this.$t("lang.common.save_success"));
                            this.onCancel();
                        } else {
                            message.error(this.$t(data.description));
                            this.loading = false;
                        }
                    },
                    (error) => {
                        this.loading = false;
                        console.log(error);
                    }
                );
        },
        agreeConfirm() {
            this.acceptanceReport.status = 2;
            this.onSave();
        },
        onConfirm() {
            this.confirmDialog = true;
        },
        agreeApprove() {
            this.acceptanceReport.status = 3;
            this.onSave();
        },
        onApprove() {
            this.approveDialog = true;
        },
        agreeReject() {
            this.acceptanceReport.status = 4;
            this.onSave();
        },
        onReject() {
            this.rejectDialog = true;
        },
        onUpdate() {
            this.onSave();
        },
        onDelete() {
            this.loading = true;
            axios
                .post(process.env.VUE_APP_API_URL + "/acceptanceReport/delete", {reportId: this.acceptanceReport.reportId})
                .then(
                    (data) => {
                        if (data) {
                            message.success( this.$t("lang.common.save_success"));
                            this.onCancel();
                        } else {
                            this.loading = false;
                        }
                    },
                    (error) => {
                        this.loading = false;
                        console.log(error);
                    }
                );
        },
        onReCreate() {
            this.$router.push({ path: '/acceptanceReport/create/' + this.acceptanceReport.reqOrdId, query: {acceptanceReportId: this.acceptanceReport.reportId} });
        },
        getAcceptanceReport() {
            if (this.$route.params.id) {
                axios
                    .post(
                        process.env.VUE_APP_API_URL + "/acceptanceReport/search?pageSize=-1&page=-1", {reportId: this.$route.params.id}
                    )
                    .then((data) => {
                        console.log(data);
                        if (data.items != undefined && data.items[0] != undefined) {
                            this.acceptanceReport = data.items[0];
                            this.lstMaterial = JSON.parse(data.items[0].requestData);
                        }
                    });
            }
        },
        getSuppliers() {
            axios.post(
                    process.env.VUE_APP_API_URL + "/partner/suppliers?pageSize=-1&page=-1",
                    { status: 1 }
                )
                .then((data) => {
                    if (data.items) {
                        this.lstSupplier = data.items;
                    }
                });
        },
        keyProcess($event) {
            let index = parseInt($event.target.getAttribute("data-index"));
            let input_id = '';
            switch ($event.keyCode) {
                case 13:
                    index += 1;
                    input_id = "input_" + index;
                    var element = document.getElementById(input_id);
                    if (typeof element != "undefined" && element != null) {
                        element.focus();
                    } else {
                        $event.target.blur(); 
                    }
                    $event.preventDefault();
                    break;
                case 38:
                    // up
                    if (index > 0) {
                        index -= 1;
                        input_id = "input_" + index;
                        var element = document.getElementById(input_id);
                        if (typeof element != "undefined" && element != null) {
                            element.focus();
                        }
                    }
                    $event.preventDefault();
                    break;
                case 40:
                    //down
                    index += 1;
                    input_id = "input_" + index;
                    var element = document.getElementById(input_id);
                    if (typeof element != "undefined" && element != null) {
                        element.focus();
                    }
                    $event.preventDefault();
                    break;
            }
        },
        dateFormat(date) {
            return moment(String(date)).format('DD-MM-YYYY');
        },
        minDate() {
            const minDate = moment().format('YYYY-MM-DD');
            return minDate;
        },
        fomarLstSupplier(item) {
            let supplier = [];
            if (this.lstSupplier.length > 0 && this.lstMaterialFull.length > 0) {
                const findMat = this.lstMaterialFull.filter(function (v) {
                    return item.materialId == v.materialId;
                });
                if (findMat.length > 0) {
                    const material = findMat[0];
                    const supplyId = ',' + material.supplyId + ',';
                    supplier = this.lstSupplier.filter(function (v) {
                        return supplyId.indexOf(',' + v.partnerId + ',') != -1;
                    });
                }
            }
            return supplier;
        },
    },

    destroyed() {},
};
</script>
